import { render } from "./mvt-inputcurrency.vue?vue&type=template&id=4a416976"
import script from "./mvt-inputcurrency.vue?vue&type=script&lang=js"
export * from "./mvt-inputcurrency.vue?vue&type=script&lang=js"

import exportComponent from "/builds/movoto/frontend/consumer-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__